// extracted by mini-css-extract-plugin
module.exports = {"input":"searchbar_input__33RJ3","button":"searchbar_button__2fg7e","form":"searchbar_form__1-3Ba"};